export class Language {
  public static defaultLanguages: Array<Language> = [
    new Language('Deutsch', 'de'),
    new Language('Englisch', 'en'),
  ];

  public text: string;
  public code: string;

  constructor(text: string, code: string) {
    this.text = text;
    this.code = code;
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/shared/classes/language.ts